// extracted by mini-css-extract-plugin
export var banner = "_2k-0";
export var icon = "_2k-1";
export var message = "_2k-2";